















































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import { GetProjectDetail } from "@/request/projects";
import {
  GetDataTables,
  GetDataTableReview,
  DeleteDataTable,
  PostExportDataTable,
  GetExportDataTable
} from "@/request/data-filter";
import Pagination from "@/components/paginaiton.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import Header from "../../../components/project-detail-header.vue";
import LeftNav from "../../../components/project-detail-left-nav.vue";
import ProjectSetting from "../../components/project-setting/project-setting.vue";
import DataTableReview from "../components/data-table-review/data-table-review.vue";
@Component({
  components: {
    Header,
    LeftNav,
    Pagination,
    ConfirmDialog,
    ProjectSetting,
    DataTableReview
  }
})
export default class DataFilterFolder extends Vue {
  private project: any = {};
  private datatable: any[] = [];
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "0";
  // 搜索
  private filters: any = {
    名称: ""
  };
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 项目设置
  private ifShowSet: boolean = false;
  // 预览弹窗
  private ifShowReview: boolean = false;
  // 确认弹窗
  private cTable: any = {};
  private confirmState = "delete";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any = "确定要删除该数据表格吗？";
  /**
   * @description 跳转创建数据表格
   */
  private goToCreateDataTable() {
    this.$router.push(
      "/main/project/create-data-table/" + this.project.project_id
    );
  }
  /**
   * @description 获取项目详情
   */
  private fetchProject() {
    return new Promise((resolve, reject) => {
      GetProjectDetail(this, this.project.project_id)
        .then((data: any) => {
          this.project = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获取数据表格列表
   */
  private fetchDataTables() {
    const params: any = {
      params: {
        search: this.filters["名称"],
        current_page: this.currentPage,
        page_count: this.pageSize,
        sort_field: this.cSortField,
        sort_value: this.cSortValue
      }
    };
    GetDataTables(this, params).then((data: any) => {
      this.datatable = data.tables;
      this.totalPage = data.total_page;
      this.totalCount = data.total_count;
    });
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchDataTables();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchDataTables();
  }
  /**
   * @description 查看
   */
  private reviewIt(table) {
    this.cTable = table;
    this.ifShowReview = true;
  }
  /**
   * @description 导出
   */
  private exportIt(table) {
    const that = this;
    PostExportDataTable(that, table.table_id).then((data: any) => {
      console.log(data);
      GetExportDataTable(data.file_name);
    });
  }
  /**
   * @description 打开是否确定删除弹窗
   */
  private opendeleteConfirm(table) {
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "确定要删除该数据表格吗？";
    this.confirmVisible = true;
    this.cTable = table;
  }
  /**
   * @description 删除
   */
  private deleteIt() {
    DeleteDataTable(this, this.cTable.table_id).then(() => {
      this.$message.success("删除成功");
      this.confirmVisible = false;
      this.fetchDataTables();
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.project.project_id = this.$route.params.project_id;
    this.fetchProject().then(() => {
      this.fetchDataTables();
    });
  }
}
